import useWindowScroll from 'beautiful-react-hooks/useWindowScroll';
import { useState } from 'react';

const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

interface IUseScrollToTopReturnValue {
  isVisible: boolean;
  scrollToTop: () => void;
}

export const useScrollToTop = (): IUseScrollToTopReturnValue => {
  const [isVisible, setVisible] = useState(false);
  const onWindowScroll = useWindowScroll();

  onWindowScroll(() => {
    setVisible(window.scrollY > 60);
  });

  return {
    isVisible,
    scrollToTop,
  };
};
